import { Auth0Provider } from '@auth0/auth0-react'
import { connect } from '@cerebral/react'
import { sequences, state } from 'cerebral'
import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import apiClient from '../lib/util/api-client'
import LoadingScreen from './elements/LoadingScreen'

const service = apiClient.service('info/tenant')

const { hostname } = window.location

const urlParams = new URLSearchParams(window.location.search)
const initialEmail = urlParams.get('email')

const TenantLoader = connect(
  {
    setInvitationParams: sequences`account.setInvitationParams`,
    setTenant: sequences`account.setTenant`,
    tenant: state`account.tenant`,
  },
  ({ setInvitationParams, setTenant, tenant, children }) => {
    useEffect(() => {
      service.find({ query: { hostname } }).then((data) => {
        if (data) {
          setTenant({ tenant: data })
        }
      })
    }, [])

    const onRedirectCallback = (appState) => {
      if (appState && appState.invitationToken) {
        const decodedUriToken = decodeURIComponent(appState.invitationToken)
        const { invitationToken } = JSON.parse(decodedUriToken)
        setInvitationParams({ token: invitationToken, email: initialEmail })
      }
    }

    return tenant ? (
      <Auth0Provider
        domain={tenant.domain}
        clientId={tenant.clientId}
        authorizationParams={{ redirect_uri: window.location.origin + '/login?email=' + encodeURIComponent(initialEmail || ''), prompt: 'select_account' }}
        onRedirectCallback={onRedirectCallback}
      >
        {children}
      </Auth0Provider>
    ) : (
      <LoadingScreen />
    )
  }
)

TenantLoader.propTypes = {
  children: PropTypes.node,
  setAccountSetting: PropTypes.func,
}

export default TenantLoader
